<template>
  <form class="form form-loyalty-signup-finalize mb-0" @submit.prevent="postConfirm">
    <slide-x-left-transition :duration="400" :delay="300">
      <div class="form-group" v-show="show">
        <label>Token:</label>
        <div class="input-wrapper">
          <input v-model="signupToken"
                 type="number"
                 :class="{'input-error' : errors['sms_token'] }"
                 placeholder="Podaj token SMS">
        </div>
        <p class="error" v-if="errors['sms_token']" v-text="errors['sms_token'][0]"></p>
      </div>
    </slide-x-left-transition>
    <slide-x-left-transition :duration="400" :delay="400">
      <p v-if="show">Jeżeli SMS nie dotarł możesz
        <a class="text-bold text-gold c-pointer" @click="resendToken()">wysłać go ponownie</a>
      </p>
    </slide-x-left-transition>
    <slide-y-up-transition :duration="500" :delay="500">
      <div v-if="show">
        <ion-button mode="ios"
                    size="small"
                    @click="postConfirm"
                    class="mt-10">Potwierdź umowę
        </ion-button>
      </div>
    </slide-y-up-transition>
  </form>
</template>

<script>
  import api from '@/services/Api';
  import { createHelpers } from 'vuex-map-fields';
  import {mapState} from "vuex";

  const { mapFields } = createHelpers({
    getterType: `loyalty/getField`,
    mutationType: `loyalty/updateField`,
  });

  export default {
    name: 'LoyaltySignupConfirm',
    computed: {
      ...mapFields({
        signupToken: 'signupToken',
      }),
      ...mapState({
        errors: state => state.loyalty.errors,
        signupUuid: state => state.loyalty.signupUuid,
      })
    },
    data() {
      return {
        show: false
      }
    },
    mounted(){
      this.show = true
    },
    methods: {
      resendToken() {
        this.$store.dispatch('loyalty/LOYALTY_CONTRACT_CONFIRM_REPEAT_REQUEST', this.signupUuid)
      },
      postConfirm(){
        let payload = { 'sms_token' : this.signupToken, 'uuid' : this.signupUuid }
        this.$store.dispatch('loyalty/LOYALTY_CONTRACT_CONFIRM_REQUEST', payload)
      }
    }
  }
</script>